import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { InfoICircleOutlined } from "@common-packages/react-icons";
import { useTranslation } from "react-i18next";
import Widget from "@components/Widget/Widget";
import { PlanOverviewAccordion } from "@features/Plan/components/PlanOverview/PlanOverviewAccordion";
import "./PlanOverviewProcessStatusesWidget.scss";
import { PlanOverviewRemarks } from "@features/Plan/components/PlanOverview/PlanOverviewRemarks";
export const PlanOverviewProcessStatusesWidget = ({ bigScreen = false }) => {
    const { t } = useTranslation();
    return (_jsxs(Widget.Container, { children: [_jsx(Widget.Header, { title: t("plan.create.statusWidget.title"), subtitle: t("plan.create.statusWidget.subtitle"), icon: {
                    component: (_jsx(InfoICircleOutlined, { width: "1rem", height: "1rem" })),
                    tooltip: {
                        id: "PlanOverviewProcessStatusesWidgetInfoTooltip",
                        html: `
                        <div>
                            <h3>${t("plan.overview.consequences")}</h3>
                            <div class="plan-overview-tooltip-info">
                                <span class="plan-overview-tooltip-info-circle plan-overview-tooltip-info-blue"></span>
                                <span>${t("plan.create.fillInProcess.fyi")}</span>
                            </div>
                            <div class="plan-overview-tooltip-info">
                                <span class="plan-overview-tooltip-info-circle plan-overview-tooltip-info-orange"></span>
                                <span>${t("plan.create.fillInProcess.someDisturbances")}</span>
                            </div>
                            <div class="plan-overview-tooltip-info">
                                <span class="plan-overview-tooltip-info-circle plan-overview-tooltip-info-red"></span>
                                <span>${t("plan.create.fillInProcess.majorDisturbances")}</span>
                            </div>
                        </div>`,
                    },
                } }), _jsx(Widget.Body, { children: _jsxs("div", { children: [_jsx("div", { className: "plan-overview-widget-remarks", children: _jsx(PlanOverviewRemarks, { bigScreen: bigScreen }) }), _jsx(PlanOverviewAccordion, { bigScreen: bigScreen })] }) })] }));
};
PlanOverviewProcessStatusesWidget.displayName = "PlanOverviewProcessStatusesWidget";
